const emailTemplates = {
  infoBannerTitle: "תבניות מייל מנוהלות ב-Supabase Auth",
  infoBannerDesc: "שינויים שנעשים שם ישפיעו מיידית על כל מיילי המערכת.",
  openInSupabase: "פתח תבניות מייל ב-Supabase",
  authEmailsTitle: "מיילי אימות",
  confirmSignUp: "אישור הרשמה",
  confirmSignUpDesc: "נשלח לאחר יצירת חשבון לאימות כתובת המייל.",
  inviteUser: "הזמנת משתמש",
  inviteUserDesc: "הזמנה שנשלחת כאשר משתמש מוזמן להצטרף למערכת.",
  magicLink: "קישור כניסה מהירה",
  magicLinkDesc: "כניסה ללא סיסמה — קישור חד-פעמי למייל.",
  changeEmail: "שינוי כתובת מייל",
  changeEmailDesc: "אימות שנשלח כאשר המשתמש מעדכן את המייל שלו.",
  resetPassword: "איפוס סיסמה",
  resetPasswordDesc: "נשלח לאחר לחיצה על 'שכחתי סיסמה'.",
  reauthentication: "אימות מחדש",
  reauthenticationDesc: "אימות נדרש לפני ביצוע פעולות רגישות.",
  securityEmailsTitle: "מיילי אבטחה",
  passwordChanged: "סיסמה שונתה",
  passwordChangedDesc: "התראה שנשלחת כאשר הסיסמה משתנה.",
  emailChanged: "כתובת מייל שונתה",
  emailChangedDesc: "התראה שנשלחת כאשר כתובת המייל משתנה.",
  phoneChanged: "מספר טלפון שונה",
  phoneChangedDesc: "התראה שנשלחת כאשר מספר הטלפון משתנה.",
  identityLinked: "ספק זהות חובר",
  identityLinkedDesc: "התראה כאשר ספק כניסה (Google / OAuth) מחובר.",
  identityUnlinked: "ספק זהות נותק",
  identityUnlinkedDesc: "התראה כאשר ספק כניסה מנותק.",
  mfaAdded: "אימות דו-שלבי הופעל",
  mfaAddedDesc: "התראה כאשר MFA מופעל.",
  mfaRemoved: "אימות דו-שלבי הוסר",
  mfaRemovedDesc: "התראה כאשר MFA מושבת.",
  variablesTitle: "משתנים דינמיים",
  varConfirmationUrl: "קישור האישור/פעולה",
  varSiteUrl: "כתובת האתר",
  varEmail: "כתובת המייל של המשתמש",
  customizationTitle: "אפשרויות התאמה",
  customSubject: "נושא המייל",
  customHtml: "גוף HTML ותוכן טקסט",
  customLayout: "עיצוב ו-layout רספונסיבי",
  customCta: "כפתור קריאה לפעולה (CTA)",
  customRtl: "תמיכה ב-RTL",
  customBrand: "לוגו וצבעי מותג",
} as const;
export default emailTemplates;
